import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"minus\">\n<path d=\"M12 0H2C0.875 0 0 0.90625 0 2V12C0 13.125 0.875 14 2 14H12C13.0938 14 14 13.125 14 12V2C14 0.90625 13.0938 0 12 0ZM9.96875 7.75H3.96875C3.5625 7.75 3.21875 7.4375 3.21875 7C3.21875 6.59375 3.53125 6.25 3.96875 6.25H9.96875C10.375 6.25 10.6875 6.59375 10.6875 7C10.7188 7.4375 10.4062 7.75 9.96875 7.75Z\" fill=\"#C4C4C4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/minus.svg
// module id = US+g
// module chunks = 13